import { Component, EventEmitter, Output } from '@angular/core';
import { Direction } from 'src/app/shared/models/documento.model';

@Component({
  selector: 'app-tipo-documento',
  template: `
  <div class="flex justify-content-center">
    <div class="item">
      <p-card styleClass="card" (click)="tipoSelected.emit(direction.Arrivo)">
        <p-header>
          <div class="card-image">
            <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="inbox-in" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-inbox-in fa-w-18 fa-3x">
              <g class="fa-group">
                <path fill="#2EA563" fill-opacity="0.4" d="M528 512H48a48 48 0 0 1-48-48v-95.2a47.29 47.29 0 0 1 10.7-30l94.4-118a12 12 0 0 1 18.1-.7l27.6 29.5a12 12 0 0 1 .6 15.7L107.6 320H200l32 64h112l32-64h92.3L424 264.6a12.16 12.16 0 0 1 .8-15.9l28.1-28.9a12.12 12.12 0 0 1 18 .9l94.6 118.2a47.77 47.77 0 0 1 10.5 29.9V464a48 48 0 0 1-48 48z" class="fa-secondary">
                </path>
                <path fill="currentColor" d="M171.5 160h61.9V17.1A17.16 17.16 0 0 1 250.5 0h68.6a17.09 17.09 0 0 1 17.1 17.1V160h68.3c17.8 0 26.7 21.5 14.1 34.1l-119.4 120a20 20 0 0 1-28.6-.3L157 193.8c-12.1-12.7-3.1-33.8 14.5-33.8z" class="fa-primary">
                </path>
              </g>
            </svg>
          </div>
        </p-header>
        <div class="card-content">In arrivo</div>
      </p-card>
    </div>
    <div class="item" (click)="tipoSelected.emit(direction.Partenza)">
      <p-card styleClass="card">
        <p-header>
          <div class="card-image">
            <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="inbox-out" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-inbox-out fa-w-18 fa-3x">
              <g class="fa-group">
                <path fill="#2EA563" fill-opacity="0.4" d="M565.6 338.89a48.27 48.27 0 0 1 10.4 29.9V464a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48v-95.2a48.05 48.05 0 0 1 10.5-30l94.4-118a12 12 0 0 1 18.1-.7l27.6 29.5a12 12 0 0 1 .6 15.7L107.6 320H200l32 64h112l32-64h92.4l-44.3-55.4a11.94 11.94 0 0 1 .8-15.9l28.1-28.9a12 12 0 0 1 18 .9z" class="fa-secondary">
                </path>
                <path fill="currentColor" d="M239.7 302.89V160h-68.3c-17.8 0-26.7-21.5-14.1-34.1l119.4-120a20 20 0 0 1 28.6.3l113.7 120c12.1 12.7 3.1 33.8-14.5 33.8h-61.9v142.9a17.18 17.18 0 0 1-17.2 17.1h-68.6a17.09 17.09 0 0 1-17.1-17.11z" class="fa-primary">
                </path>
              </g>
            </svg>
          </div>
        </p-header>
        <div class="card-content">In partenza</div>
      </p-card>
    </div>
  </div>
  `,
  styles: [`
    .item { cursor: pointer; width: 280px; margin-right: 50px; }
    .card-image { text-align: center; }
    .card-image > img { max-width: 230px; }
    .card-content { text-align: center; font-size: 40px; }
  `]
})

export class TipoDocumentoComponent {
  @Output() tipoSelected = new EventEmitter<Direction>();

  public direction = Direction;
}
